var _path, _path2, _circle, _circle2, _circle3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.96-4.18A2.5 2.5 0 0 1 9.5 2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.96-4.18A2.5 2.5 0 0 0 14.5 2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 9,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 9,
    r: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9L12 11L17 9",
    strokeDasharray: "1,2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContext);
export default __webpack_public_path__ + "static/media/icon-context.872d7ea47ae9b11c83af802b6a1fcf9d.svg";
export { ForwardRef as ReactComponent };